<template>
  <div class="post">
    <van-nav-bar
      :title="topTitle"
      :right-text="lang.topclear"
      :left-arrow="!$route.query.fromapp"
      @click-left="goAway"
      @click-right="clear"
    />
    <!-- up_photo -->
    <div>
      <!-- 有图片的时候展示的结构 -->
      <div
        v-if="propertyInfo && propertyInfo.images && propertyInfo.images.length"
        class="imgshow"
        @click="$router.push('/post/photos?type=edit/')"
      >
        <van-swipe
          :height="217"
          :show-indicators="false"
          @change="changeSwipe"
        >
          <van-swipe-item
            v-for="(item, idx) in propertyInfo.images"
            :key="idx"
          >
            <img :src="item.imagePath | imgResize('list')">
          </van-swipe-item>
        </van-swipe>
        <div class="picnum">
          <span>{{ current }}/{{ propertyInfo.images.length }}</span>
        </div>
        <!-- 图片数量  -->
      </div>
      <!-- 图片未上传的时候展示的结构 -->
      <div
        v-else
        class="addPic"
        @click="$router.push('/post/photos/')"
      >
        <svg
          class="icon icon_ph"
          aria-hidden="true"
        >
          <use xlink:href="#icon-xiangjix" />
        </svg>
        <p>{{ lang.addPic }}</p>
        <p class="add_text">
          {{ lang.addTips }}
        </p>
        <p class="topOne">
          {{ lang.topOne }}
        </p>
      </div>
    </div>
    <!-- 标题 -->
    <div class="tit">
      <span class="num">1</span>
      <span class="titname">{{ lang.titOne }}</span>
    </div>
    <!-- Userinfo -->
    <div
      ref="from"
      class="userInfo"
    >
      <!-- 代理选择  业主盘：新增复制可修改盘源类型,代理盘：新增复制修改都不可修改盘源类型-->
      <van-cell
        :title="lang.agent"
        required
        :is-link="(Source == 1 && mode == 'post') || (Source == 1 && mode == 'copy') || chooseSource"
        :value="soureText"
        @click="choosePro"
      />
      <van-popup
        v-model="showList"
        position="top"
        class="choose"
        :overlay="false"
      >
        <van-nav-bar
          :title="lang.selsctSource"
          left-arrow
          :right-text="lang.confirm"
          @click-left="showList = false"
          @click-right="showList = false"
        />
        <van-radio-group v-model="propertySource">
          <van-cell
            v-for="item in DPropertySource"
            :key="item.dictionaryValue"
            :title="item.dictionaryNameWithCulture"
            @click="propertySource = item.dictionaryValue"
          >
            <van-radio
              :name="item.dictionaryValue"
              :value="item.dictionaryValue"
              checked-color="#ED1818"
            />
          </van-cell>
        </van-radio-group>
      </van-popup>
      <van-field
        v-model="userInfo.contactNameCN"
        :label="lang.contactNameChi"
        input-align="right"
        required
        maxlength="20"
        type="text"
        @click="post.goPosition($event, $route.query.fromapp)"
      />
      <van-field
        v-model="userInfo.email"
        :label="lang.email"
        input-align="right"
        required
        maxlength="50"
        type="text"
        @click="post.goPosition($event, $route.query.fromapp)"
      />
      <van-field
        v-model="userInfo.telphone"
        :label="lang.tel"
        input-align="right"
        required
        type="tel"
        @click="post.goPosition($event, $route.query.fromapp)"
      />
      <van-cell
        :title="lang.telShow"
        :value="teltxt"
        class="telShow"
        is-link
        required
        @click="telShow = true"
      />
      <van-popup
        v-model="telShow"
        position="top"
        class="choose"
        :overlay="false"
      >
        <van-nav-bar
          :title="lang.telShow"
          left-arrow
          :right-text="lang.confirm"
          @click-left="telShow = false"
          @click-right="telShow = false"
        />
        <van-radio-group v-model="userInfo.isShowTel">
          <van-cell
            :title="lang.showPhone"
            clickable
            @click="showTel(true)"
          >
            <van-radio
              :name="true"
              checked-color="#ED1818"
            />
          </van-cell>
          <van-cell
            :title="lang.dontShow"
            clickable
            @click="showTel(false)"
          >
            <van-radio
              :name="false"
              checked-color="#ED1818"
            />
          </van-cell>
        </van-radio-group>
        <!-- 电话展示 -->
        <div
          v-if="userInfo.isShowTel === true"
          class="disTel"
        >
          <van-checkbox-group v-model="Telresult">
            <van-cell
              v-for="(item, index) in lang.tool"
              :key="index"
              clickable
              :title="item"
              @click="toggle(index)"
            >
              <van-checkbox
                ref="checkboxes"
                :name="index"
                checked-color="#ED1818"
              />
            </van-cell>
          </van-checkbox-group>
        </div>
      </van-popup>
    </div>
    <div class="next">
      <van-button
        size="large"
        class="nextBtn"
        :class="{ opc: VerifyNext }"
        @click="next"
      >
        {{ lang.next }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import lang from './../../../common/language/post';
import post from './../../../common/js/post';
export default {
  name: 'Step1',
  data() {
    return {
      post,
      lang,
      chooseSource: false, // 开启代理切换业主
      Source: -1,
      close: false,
      current: 1,
      showList: false, // 选择房源展示
      telShow: false, // 电话展示弹出层
      teltxt: '', //电话是否展示文字
      Telresult: [], // 0 是 whatsAPP  1 Wechat
      soureText: '',
      propertySource: '', //盘源value  1业主  2代理
      DPropertySource: [], //字典盘源
      topTitle: '',
      query: '',
      userInfo: {
        userID: '',
        mode: '',
        contactNameCN: '',
        email: '',
        telphone: '',
        isShowTel: '',
        isShowWhatsApp: false,
        isShowWeChat: false
      }
    };
  },
  watch: {
    images(file) {
      if (file && file.length > 20) {
        this.file = this.file.slice(0, 20);
      }
    },
    propertySource(data) {
      if (data === '') {return;}
      this.soureText = post.getDictionaryText(this.propertySource, this.DPropertySource);
    },
    Telresult(data) {
      this.userInfo.isShowWhatsApp = data.indexOf(0) > -1;
      this.userInfo.isShowWeChat = data.indexOf(1) > -1;
    },
    'userInfo.isShowTel'(data) {
      if (data === undefined || data === '') {
        this.teltxt = '';
      } else if (data) {
        this.teltxt = lang.showPhone;
      } else {
        this.teltxt = lang.dontShow;
        this.userInfo.isShowWhatsApp = false;
        this.userInfo.isShowWeChat = false;
      }
    }
  },
  computed: {
    ...mapState(['propertyUserInfo', 'propertyInfo', 'dictionary', 'showBtn']),
    VerifyNext() {
      // 所有信息全部填写则按钮高亮
      if (this.soureText && this.userInfo.contactNameCN && this.userInfo.email && this.userInfo.telphone && this.teltxt) {
        return false;
      } 
        return true;
      
    }
  },
  created() {
    this.getDictionary(); // 获取字典
    this.topTitle = post.getTitle(this, this.lang); //获取title
    if (this.propertyInfo && JSON.stringify(this.propertyInfo) !== '{}') {
      this.getProData();
    }
    if (this.propertyUserInfo && JSON.stringify(this.propertyUserInfo) !== '{}') {
      this.getState();
    }
    post.getQuery(this);
  },
  methods: {
    ...mapMutations(['setUserData', 'setProperty', 'stepChange', 'clearStep1', 'clearAll']),
    getState() {
      this.userInfo = Object.assign({}, this.propertyUserInfo);
      if (this.mode == 'post') {
        if (this.propertyInfo.Source) {
          this.propertySource = String(this.propertyInfo.propertySource);
          this.Source = this.propertyInfo.Source;
        } else {
          this.propertySource = String(this.userInfo.propertySource);
          this.Source = this.userInfo.propertySource;
        }
      } else {
        this.propertySource = String(this.propertyInfo.propertySource);
        if (this.propertyInfo.Source) {
          this.Source = this.propertyInfo.Source;
        } else {
          this.Source = this.propertyInfo.propertySource;
        }
      }
      if (this.propertyUserInfo.isShowWhatsApp && this.propertyUserInfo.isShowWeChat) {
        this.Telresult.push(0, 1);
      } else if (this.propertyUserInfo.isShowWhatsApp) {
        this.Telresult.push(0);
      } else if (this.propertyUserInfo.isShowWeChat) {
        this.Telresult.push(1);
      }
    },
    changeSwipe(index) {
      this.current = index + 1;
    },
    getDictionary() {
      this.DPropertySource = this.dictionary['PropertySource'].children;
    },
    choosePro() {
      if ((this.Source == 1 && this.mode == 'post') || (this.Source == 1 && this.mode == 'copy') || this.chooseSource) {
        this.showList = true;
      } else {
        this.showList = false;
      }
    },
    getProData() {
      if (this.propertyInfo && this.propertyInfo.images && this.propertyInfo.images.length) {
        this.propertyInfo.images.forEach((items, index) => {
          if (items.isDefault == true) {
            if (index == 0) {
              return;
            } 
              this.propertyInfo.images.unshift(this.propertyInfo.images.splice(index, 1)[0]);
            
          }
        });
      }
    },
    next() {
      if (this.validate_required()) {
        this.setUserData({ ...this.userInfo });
        this.setProperty({ propertySource: this.propertySource, Source: this.Source });
        if (this.propertyInfo.images == undefined || this.propertyInfo.images.length == 0) {
          return this.$dialog
            .confirm({
              title: lang.nopic,
              message: lang.continue,
              cancelButtonText: lang.cancel,
              confirmButtonText: lang.confirm
            })
            .then(() => {
              if (this.propertySource == 1) {
                this.stepChange(3);
                this.$router.push('/post/step3/' + this.query);
              }
              if (this.propertySource == 2) {
                this.stepChange(2);
                this.$router.push('/post/step2/' + this.query);
              }
            });
        } 
          if (this.propertySource == 1) {
            this.stepChange(3);
            this.$router.push('/post/step3/' + this.query);
          }
          if (this.propertySource == 2) {
            this.stepChange(2);
            this.$router.push('/post/step2/' + this.query);
          }
        
      }
    },
    showTel(data) {
      if (!data) {
        this.Telresult = [];
      } // 如果不显示 清空下显示WhatsApp & WeChat
      if (this.userInfo.isShowTel == undefined) {
        this.$set(this.userInfo, 'isShowTel', data);
      } else {
        this.userInfo.isShowTel = data;
      }
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    goAway() {
      this.$dialog
        .confirm({
          title: lang.confrimExit,
          message: lang.goaway,
          cancelButtonText: lang.cancel,
          confirmButtonText: lang.confirm
        })
        .then(() => {
          this.close = true;
          if (this.$route.query && this.$route.query.type) {
            this.$router.push(`/editProDetail/${this.$route.query.id}/`);
          } else {
            this.$router.push('/');
          }
        });
    },
    clear() {
      this.$dialog
        .confirm({
          title: lang.Clearcontent,
          cancelButtonText: lang.cancel,
          confirmButtonText: lang.confirm
        })
        .then(() => {
          this.clearInfo();
        });
    },
    validate_required() {
      if (!this.soureText.trim()) {
        this.$notify(lang.require1.source);
        return;
      }
      if (!this.userInfo.contactNameCN.trim()) {
        this.$notify(lang.require1.Cname);
        return;
      }
      if (!this.userInfo.email.trim()) {
        this.$notify(lang.require1.email);
        return;
      }
      let checkEmail = /^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!checkEmail.test(this.userInfo.email.trim())) {
        this.$notify(lang.require1.emailFormat);
        return;
      }
      if (!this.userInfo.telphone.trim() || this.userInfo.telphone.trim() == '') {
        this.$notify(lang.require1.tel);
        return;
      }
      // 8 位数字 不能0,1开头
      if (post.verifTel(this.userInfo.telphone)) {
        this.$notify(lang.require1.telFormat);
        return;
      }

      if (!this.teltxt.trim()) {
        this.$notify(lang.require1.telShow);
        return;
      }
      return true;
    },
    clearInfo() {
      //  1.清空 vuex 中的数据
      this.clearStep1();
      //  2. 清空本页面的v-model 的数据
      this.propertyInfo.images = [];
      this.userInfo.contactNameCN = '';
      this.userInfo.email = '';
      this.userInfo.telphone = '';
      this.$set(this.userInfo, 'isShowTel', '');
      this.Telresult = [];
    }
  },
  beforeDestroy() {
    this.setUserData({ ...this.userInfo });
    this.setProperty({ propertySource: this.propertySource, Source: this.Source });
    if (this.close) {
      this.clearAll();
    }
  }
};
</script>

<style scoped lang="scss">
.opc {
  opacity: 0.5;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
// .post {
//   padding-bottom: 64px;
//   // box-sizing: border-box;
// }
.imgshow {
  height: 217px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .picnum {
    position: absolute;
    right: 16px;
    bottom: 10px;
    width: 64px;
    border-radius: 15px;
    color: #ffffff;
    background: rgba(41, 38, 48, 0.6);
    border-radius: 100px;
    box-sizing: border-box;
    font-size: 20px;
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
  .icon_photo {
    height: 100%;
    vertical-align: middle;
    margin-right: 8px;
  }
  span {
    // vertical-align: middle;
    font-size: 14px;
  }
}
.addPic {
  background-color: #fff;
  width: 100%;
  height: 217px;
  text-align: center;
  box-sizing: border-box;
  padding-top: 35px;

  p {
    line-height: 30px;
  }
  .icon_ph {
    font-size: 44px;
    text-align: center;
  }
  .add_text {
    color: #999999;
    margin-top: 15px;
  }
}
.userInfo {
  .telShow {
    margin-top: 16px;
  }
  .van-field__label {
    max-width: 120px;
  }
  .choose {
    height: 100%;
    background-color: #f5f6f7;
  }
  .disTel {
    margin-top: 16px;
  }
}
// 修改vant label 宽度
/deep/.van-field__label {
  max-width: 120px;
}

.next {
  background-color: #001a33;
  height: 64px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  .nextBtn {
    border-radius: none;
    color: #fff;
    background-color: #001a33;
    height: 44px;
    width: 90%;
    margin: 10px 5%;
  }
}
.topOne {
  color: red;
}
</style>
